import loader from "../../assets/images/loading.gif";

const VerifyingPaymentLoader = () => {
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 9999
      }}
    >
      <div
        className="d-flex flex-column align-items-center justify-content-center p-4"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          borderRadius: "12px",
          minWidth: "260px",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)"
        }}
      >
        <img
          src={loader}
          alt="Verifying"
          className="img-fluid"
          style={{ height: "50px", marginBottom: "20px" }}
        />
        <p style={{ margin: 0, fontWeight: 500, fontSize: "1rem", color: "#fff" }}>
          Verifying payment...
        </p>
      </div>
    </div>
  );
};

export default VerifyingPaymentLoader;
